<router-outlet>
    <app-spinner *ngIf="isLoading && !hideSpinnerOnDashboard"></app-spinner>
</router-outlet>
